import { useState, useEffect } from "react";
import "./css/adminsaleproduct.css";
import { getSaleProducts, restrictProducts, /* deleteProducts, */ searchSaleProducts } from "../../utils/adminProductService";
import { downloadSaleProductExcel } from "../../utils/adminExcelService";
import { formatDateTime24 } from "../../utils/commonService";
import { useNavigate } from "react-router-dom";
import Pagination from "../common/Pagination";

const AdminSaleProduct = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isBulkRestrictionModalOpen, setIsBulkRestrictionModalOpen] = useState(false);
  const [bulkRestrictionReason, setBulkRestrictionReason] = useState("");
  
  // 페이지네이션 상태
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const pageSize = 10;
  
  // 검색 여부 플래그
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  
  // 필터 상태
  const [filters, setFilters] = useState({
    startDateFrom: "",
    startDateTo: "",
    endDateFrom: "",
    endDateTo: "",
    category: "all-category",
    saleStatus: "all",
    searchType: "all",
    searchKeyword: "",
  });

  // 상품 목록 조회
  useEffect(() => {
    loadProducts();
  }, []);


  const loadProducts = async (page = 0) => {
    const result = await getSaleProducts(page, pageSize);
    if (result.success) {
      setProducts(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setIsSearchMode(false);
    }
  };

  // 제재 사유 입력 후 제출
  const handleBulkRestrictionSubmit = async () => {
    const result = await restrictProducts(selectedProducts, bulkRestrictionReason);
    if (result.success) {
      alert(result.data);
      setSelectedProducts([]);
      setBulkRestrictionReason("");
      setIsBulkRestrictionModalOpen(false);
      if (isSearchMode) {
        handleSearchInternal(currentPage);
      } else {
        loadProducts(currentPage);
      }
    } else {
      alert(result.error);
    }
  };

  // 제재 모달 취소
  const handleBulkRestrictionCancel = () => {
    setBulkRestrictionReason("");
    setIsBulkRestrictionModalOpen(false);
  };

  // 검색 내부 함수
  const handleSearchInternal = async (page = 0) => {
    const searchParams = {
      startDateFrom: filters.startDateFrom,
      startDateTo: filters.startDateTo,
      endDateFrom: filters.endDateFrom,
      endDateTo: filters.endDateTo,
      categoryNm: filters.category,
      searchTerm: filters.searchKeyword,
      searchType: filters.searchType,
    };

    const result = await searchSaleProducts(searchParams, page, pageSize);
    if (result.success) {
      setProducts(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setIsSearchMode(true);
    } else {
      alert(result.error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    isSearchMode ? handleSearchInternal(page) : loadProducts(page);
  };

  // 검색 버튼 클릭
  const handleSearch = () => {
    setCurrentPage(0);
    handleSearchInternal(0);
  };

  // 필터 초기화
  const handleReset = () => {
    setFilters({
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
      category: "all-category",
      saleStatus: "all",
      searchType: "all",
      searchKeyword: "",
    });
    setCurrentPage(0);
    loadProducts(0);
  };

  return (
    <div className="adminsaleproduct-container">
      <div className="adminsaleproduct-wrap">
        {/* 탭 네비게이션 */}
        <div className="adminsaleproduct-tab-navigation">
          <button className="adminsaleproduct-tab-btn adminsaleproduct-tab-active">
            할인 진행 목록
          </button>
          <button className="adminsaleproduct-tab-btn" onClick={() => {
            navigate("/admin/product/sale/complete");
          }}>
            할인 완료 목록
          </button>
        </div>        
        <div className="adminsaleproduct-filter-wrap">
          <div className="adminsaleproduct-filter-row">
            <div className="adminsaleproduct-filter-group">
              <label>시작일시 기준</label>
              <input 
                type="date" 
                className="adminsaleproduct-date-input"
                value={filters.startDateFrom}
                onChange={(e) => setFilters({...filters, startDateFrom: e.target.value})}
              />
              <span>~</span>
              <input 
                type="date" 
                className="adminsaleproduct-date-input"
                value={filters.startDateTo}
                onChange={(e) => setFilters({...filters, startDateTo: e.target.value})}
              />
            </div>
          </div>
          <div className="adminsaleproduct-filter-row">
            <div className="adminsaleproduct-filter-group">
              <label>종료일시 기준</label>
              <input 
                type="date" 
                className="adminsaleproduct-date-input"
                value={filters.endDateFrom}
                onChange={(e) => setFilters({...filters, endDateFrom: e.target.value})}
              />
              <span>~</span>
              <input 
                type="date" 
                className="adminsaleproduct-date-input"
                value={filters.endDateTo}
                onChange={(e) => setFilters({...filters, endDateTo: e.target.value})}
              />
            </div>
          </div>

          <div className="adminsaleproduct-filter-row adminsaleproduct-search-row">
            <div className="adminsaleproduct-search-group">
              <select
                name="column"
                id="column"
                className="adminsaleproduct-select-type"
                value={filters.searchType}
                onChange={(e) => setFilters({...filters, searchType: e.target.value})}
              >
                <option value="all">전체</option>
                <option value="productNm">상품명</option>
                <option value="storeNm">가맹점명</option>
              </select>
              <input
                type="text"
                placeholder="검색어를 입력해주세요."
                className="adminsaleproduct-input"
                value={filters.searchKeyword}
                onChange={(e) => setFilters({...filters, searchKeyword: e.target.value})}
              />
              <button className="adminsaleproduct-search-btn" onClick={handleSearch}>검색</button>
              <button className="adminsaleproduct-reset-btn" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>

        <div className="adminsaleproduct-table-wrap">
          <div className="adminsaleproduct-table-header">
            <div className="adminsaleproduct-table-info">
              총 <span className="adminsaleproduct-count">{totalElements}</span>건
            </div>
            <button
              className="adminsaleproduct-excel-btn"
              onClick={async () => {
                setExcelLoading(true);
                const result = await downloadSaleProductExcel();
                if (!result.success) alert(result.error);
                setExcelLoading(false);
              }}
              disabled={excelLoading}
            >
              {excelLoading ? "다운로드 중..." : "엑셀 다운로드"}
            </button>
          </div>

          <table className="adminsaleproduct-table">
            <thead>
              <tr>
                <th>가맹점</th>
                <th>상품명</th>
                {/* <th>성인상품</th> */}
                <th>할인액</th>
                <th>원가</th>
                <th>판매가</th>
                <th>상태</th>
                <th>시작일시</th>
                <th>종료일시</th>
              </tr>
            </thead>
            <tbody>
              {products.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: 'center' }}>
                    등록된 상품이 없습니다.
                  </td>
                </tr>
              ) : (
                products.map((product, index) => (
                  <tr key={product.productCode}>
                    <td>{product.storeNm}</td>
                    <td>{product.productNm}</td>
                    {/* <td>{product.isAdult ? "O" : "X"}</td> */}
                    <td>{product.saleType === "할인률" ? `${product.saleValue}%` : `${product.saleValue?.toLocaleString()}원`}</td>
                    <td>{product.originalPrice?.toLocaleString()}원</td>
                    <td>{product.discountedPrice?.toLocaleString()}원</td>
                    <td>{product.saleStatus}</td>
                    <td>{formatDateTime24(product.startDateTime)}</td>
                    <td>{formatDateTime24(product.endDateTime)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* 페이지네이션 */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      {isBulkRestrictionModalOpen && (
        <div className="adminsaleproduct-modal-backdrop" onClick={handleBulkRestrictionCancel}>
          <div className="adminsaleproduct-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="adminsaleproduct-modal-header">
              <h2>상품 제재</h2>
            </div>
            <div className="adminsaleproduct-modal-body">
              <p className="adminsaleproduct-modal-info">
                선택한 {selectedProducts.length}개의 상품을 제재하시겠습니까?
              </p>
              <div className="adminsaleproduct-form-group">
                <label htmlFor="bulkRestrictionReason" className="adminsaleproduct-label">제재 사유</label>
                <textarea
                  id="bulkRestrictionReason"
                  className="adminsaleproduct-textarea"
                  value={bulkRestrictionReason}
                  onChange={(e) => setBulkRestrictionReason(e.target.value)}
                  placeholder="제재 사유를 입력해주세요"
                  rows="4"
                />
              </div>
            </div>
            <div className="adminsaleproduct-modal-footer">
              <button 
                className="adminsaleproduct-btn adminsaleproduct-btn-cancel"
                onClick={handleBulkRestrictionCancel}
              >
                취소
              </button>
              <button 
                className="adminsaleproduct-btn adminsaleproduct-btn-confirm"
                onClick={handleBulkRestrictionSubmit}
              >
                제재하기
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSaleProduct;
